<template>
  <v-app style="background-color: #e8e8e8">
    <div v-if="isClientSet">
      <router-view></router-view>
    </div>
    <div v-else>
      <fail></fail>
    </div>
  </v-app>
</template>  

<script>
import Fail from "@/views/Fail.vue";
import VueCookies from "vue-cookies";

export default {
  name: "App",
  components: {
    Fail,
  },
  computed: {
    isClientSet() {
      if (VueCookies.isKey("client")) {
        return true;
      } else {
        window.location.assign(
          window.location.origin + "/" + window.location.hostname.split(".")[0]
        );
        return false;
      }
    },
  },
};
</script>
<style>
.basicPaddingTop {
  padding-top: 50px;
}

/* Animation fade effect */
.fade-leave-active {
  transition: opacity 1s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/*.fade-enter-to {
  opacity: 1;
}
.fade-enter {
  opacity: 1;
}
.fade-leave {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}*/

/* Marching ants */
@keyframes ants {
  to {
    background-position: 100%;
  }
}
.marching-ants {
  border: 2px solid transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(
        -45deg,
        forestgreen 0,
        forestgreen 25%,
        white 0,
        white 50%
      )
      0 / 0.6em 0.6em;
  animation: ants 18s linear infinite;
}
.hover-item {
  cursor: pointer;
}
</style>
